export default {
    data() {
        return {
            currentModal: null,
            currentModalParams: {},
        }
    },

    watch: {
        currentModal() {
            if (typeof this.saveState === 'function') {
                this.saveState()
            }
        },
    },

    methods: {
        openModal(name, params) {
            this.currentModal = name
            this.currentModalParams = typeof params === 'undefined' ? {} : params
            this.saveModalState()
        },

        closeModal() {
            this.currentModal = null
            this.currentModalParams = {}
            this.saveModalState()
        },

        switchModal(name) {
            this.closeModal()
            setTimeout(() => this.openModal(name), 200)
        },

        saveModalState() {
            if (typeof this.saveState === 'function') {
                this.saveState()
            }
        },
    },
}
